import React, {useContext, useState} from 'react';
import Button from '@components/button';
import i18nStrings from './strings';
import {useLocalized} from 'utils/useLocalized';
import Link from '@components/link';
import {catchWithMsg} from 'utils/http';
import {handleResult} from 'as-ui-kit/utils/http';
import styles from './styles.modules.scss';
import * as PropTypes from 'prop-types';
import {DataContext} from 'contexts';
import Ellipsis from 'components/Ellipsis';

const Contacts = ({firmId}) => {
    const strings = useLocalized(i18nStrings);
    const { searchResultsParams} = useContext(DataContext);

    const [isContactsShown, setIsContactsShown] = useState(false);
    const [contacts, setContacts] = useState({
	    mostActiveContactId: null,
	    mostActiveContactName: null,
	    lastActiveContactId: null,
	    lastActiveContactName: null,
    });
    const [isContactsLoading, setContactsLoading] = useState(false);

    const handleContactsShowClick = async () => {
	    setContactsLoading(true);

        try {
            const response  = await fetch('/gw/vandamus/public/v1/active_truckers/active_contacts', {
                method: 'POST',
                body: JSON.stringify({
	                ati_id: Number(firmId),
	                begin_date: searchResultsParams.beginDate,
	                from: searchResultsParams.from,
	                to: searchResultsParams.to,
	                truck_weight: searchResultsParams.truckWeight,
	                truck_volume: searchResultsParams.truckVolume,
	                truck_type: searchResultsParams.truckType,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const result = await handleResult(response);
	        setContacts({
		        lastActiveContactId: result.last_active_contact_id,
		        lastActiveContactName: result.last_active_contact_name,
		        mostActiveContactId: result.most_active_contact_id,
		        mostActiveContactName: result.most_active_contact_name
	        });
        } catch (e) {
	        catchWithMsg(e);
        } finally {
	        setContactsLoading(false);
        }

        setIsContactsShown(true);
    };
    const isLastAndMostContactsAreTheSame = contacts.mostActiveContactId === contacts.lastActiveContactId;

    return isContactsShown ? (
        <div className={styles['contacts']}>
            {contacts.lastActiveContactName && (
	            <div className={styles['contact']}>
		            <Ellipsis tooltipText={contacts.lastActiveContactName}>
			            <Link
				            href={`/firms/${firmId}/contacts#contact${contacts.lastActiveContactId}`}
				            target="_blank"
			            >
				            {contacts.lastActiveContactName}
			            </Link>
		            </Ellipsis>
		            <span className={styles['label']}>
		                {isLastAndMostContactsAreTheSame ? strings.lastAndMostActive : strings.lastActive}
	                </span>
	            </div>
            )}
            {(!isLastAndMostContactsAreTheSame && contacts.mostActiveContactName) && (
	            <div className={styles['contact']}>
		            <Ellipsis>
			            <Link
				            href={`/firms/${firmId}/contacts#contact${contacts.mostActiveContactId}`}
				            target="_blank"
			            >
				            {contacts.mostActiveContactName}
			            </Link>
		            </Ellipsis>
		            <span className={styles['label']}>
			            {strings.mostActive}
		            </span>
	            </div>
            )}
        </div>
    ) : (
        <Button
            loading={isContactsLoading}
            size="small"
            onClick={handleContactsShowClick}
        >
            {strings.showContacts}
        </Button>
    );
};

export default Contacts;

Contacts.propTypes = {
    firmId: PropTypes.string
};
